<template>
  <m-card202 class="commentCard1 border p-2 rounded-sm">
    <template #p-1>
      <img :src="isUserAvatar" :alt="commentUser.name" class="avatar-icon">
      <span class="mr-2">
        {{ userAndLastname }}
      </span>
    </template>
    <template #p-2>
      <div class="row justify-content-md-end justify-content-start commentCard1-data-and-rating p-3">
             <span class="border rounded-sm ml-2 px-1">
               <i class="star-rate bi bi-star-fill"></i>
               {{ comment.rate }}
             </span>
        {{ dateConverter(comment.created_at, '/', true) }}
      </div>
    </template>
    <template #p-3>
      <div class="font-weight-light col-12 my-1" v-html="comment.body"></div>
    </template>
  </m-card202>
</template>

<script>
import {defineComponent} from 'vue'
import mRate1 from "../Rate/Rate1.vue";
import {userAvatar} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/User";
import mCard202 from "../../Cards/Card202";
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default defineComponent({
  name: "CommentCard1",
  components: {mRate1, mCard202},
  props: {
    comment: {}
  },
  data() {
    return {
      userAvatar
    }
  },
  computed: {
    commentUser() {
      return this.comment.user;
    },
    isUserAvatar() {

      let userImage = this.comment.user.image;
      if (userImage == null) {
        return this.userAvatar;
      }

      return userImage
    },
    userAndLastname() {
      return this.comment.user.name + ' ' + this.comment.user.last_name;
    }
  },
  methods: {
    dateConverter,
  }
})
</script>

<style scoped>
.commentCard1-data-and-rating {
  font-size: small;
}

.avatar-icon {
  width: 30px;
  height: 30px;
}

.star-rate {
  color: #FFD83D;
  font-size: small;
}
</style>